import React, { useContext, useEffect, useState } from "react";
import { ERROR_MESSAGES } from "../../components/common/GlobalMassssage";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import Select from "react-select";
import {
  AddUpdateProject,
  GetClientTypeLookupList,
  GetProjectModel,
} from "../../services/Project/projectApi";
import { useNavigate, useLocation } from "react-router-dom";
import { GetServiceLookupList } from "../../services/SettingApi/Service/ServiceApi";
import SuccessModal from "../../components/common/SuccessModal";
import { GetDivisionalCategoryLookupList, GetStateLookupList, GetAssignedDocumentTypeList } from "../../services/Divisional Category/DivisionalCategoryApi";
import { globalSelectStyles } from "../../middleware/enum";
import { ZoneLookupList } from "../../services/Zone/ZoneApi";
import { GetSubDivisionalCategoryLookupList } from "../../services/DivisionalSubcategory/DivisionalSubcategoryAPI";
import { GeStatusLookupList, GetCityLookupList, GetProjectManagerLookupList, GetSiteEngineerLookupList, GetTeamLeadLookupList } from "../../services/Staff/StaffApi";
import { UploadImageWithNodeApi } from "../../services/Media/UploadMedia";
import { formatInputValue } from "../../Utils/stringFormatter";
import ErrorModal from "../../components/common/ErrorModel";
import DatePicker from 'react-date-picker';
import { FaEye } from "react-icons/fa";
import { customSelectStyles } from "../../middleware/Utils";

const AddProjectModal = ({
  isOpen,
  onClose,
  setIsAddUpdateDone,
  modelRequestData,
  clientKeyID,
}) => {
  const { userKeyID } = JSON.parse(localStorage.getItem("login"));
  const navigate = useNavigate();
  const [stageObj, setStatusObj] = useState({
    projectStageKeyID: null,
    statusName: "",
  });
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const minDate = new Date(1950, 0, 1);
  const [errorMessage, setErrorMessage] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const [projectKeyID, setProjectKeyID] = useState(null);
  const [serviceLookupList, setServiceLookupList] = useState([]);
  const [serviceKeyIDs, setServiceKeyIDs] = useState([]);
  const [serviceHours, setServiceHours] = useState({});
  const { authDetails, PanalModuleName } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [divisionalCategoryLookupList, setDivisionalCategoryLookupList] = useState([]);
  const [stateLookupList, setStateLookupList] = useState([]);
  const [zoneDivisionalLookupList, setZoneDivisionalLookupList] = useState([])
  const [subDivisionalCategoryLookupList, setSubDivisionalCategoryLookupList] = useState([])
  const [siteEngineerLookupList, setSiteEngineerLookupList] = useState([]);
  const [teamLeadLookupList, setTeamLeadLookupList] = useState([])
  const [projectMangerLookupList, setProjectManagerLookupList] = useState([])
  const [projectStatusLookupList, setProjectStatusLookupList] = useState([]);
  const [clientLookupList, setClientLookupList] = useState([]);
  const [cityLookupList, setCityLookupList] = useState([]);
  const [documentDetails, setDocumentDetails] = useState([]);

  const GetDocumentDetailsData = async (divisionalCategoryID) => {
    try {
      const response = await GetAssignedDocumentTypeList(
        divisionalCategoryID
      );

      if (
        response?.statusCode === 200 &&
        response?.responseData?.data
      ) {
        const documents = response.responseData.data.map((item, index) => ({
          id: item.divisionalCategoryDocumentTypeID,
          fileName: item.documentTypeName,
          timeSpan: 1,
          employeeID: null,
          documentTypeID: item.documentTypeID,
          documentTypeKeyID: item.documentTypeKeyID,
          divisionalCategoryDocumentTypeID:
            item.divisionalCategoryDocumentTypeID,
        }));

        setDocumentDetails(documents);
      } else {
        setDocumentDetails([]);
      }
    } catch (error) {
      console.error("Error fetching document details:", error);
      setDocumentDetails([]);
    }
  };

  const [project, setProject] = useState({
    userKeyID: userKeyID,
    projectKeyID: null,
    projectName: null,
    clientID: null,
    stateID: null,
    cityID: null,
    zoneID: null,
    divisionalCategoryID: null,
    divisionalSubCategory: null,
    clientCost: null,
    technolandCost: null,
    startDate: null,
    endDate: null,
    projectStatusID: null,
    costTracking: null,
    assignedPM: null,
    assignedTL: [],
    siteEngineer: null,
    imageURL: null,
    errors: {},
    projectType: null
  });

  useEffect(() => {
    setModelAction(modelRequestData.Action === null ? "Add" : "Update");

    if (
      modelRequestData.KeyID !== undefined &&
      modelRequestData.KeyID !== null &&
      modelRequestData.Action === "Update"
    ) {
      GetProjectModalData(modelRequestData.KeyID);
    } else {
      setDocumentDetails([]);
      // Reset states for Add mode
      setProject({
        projectKeyID: null,
        projectName: "",
        price: "",
        timeLineDays: "",
        paymentTerms: "",
        remark: "",
        technolandCost: null,
        clientID: modelRequestData?.clientID || null,
        projectType: modelRequestData.clientType === true ? 0 : modelRequestData.clientType === false ? 1 : null
      });

      setServiceKeyIDs([]);
      setServiceHours({});
    }
  }, [modelRequestData]);

  useEffect(() => {
    if (project.divisionalCategoryID) {
      GetSubDivisionalLookupListData();
    }

    // if (project.divisionalCategoryID && project.projectType === 1) {
    //   GetDocumentDetailsData(project.divisionalCategoryID);
    // } else {
    //   setDocumentDetails([]);
    // }
  }, [project.divisionalCategoryID]);

  useEffect(() => {
    if (project.stateID) {
      GetCityLookupListData(project.stateID)
    }
  }, [project.stateID])

  useEffect(() => {
    if (project.projectType !== undefined && project.projectType !== null) {
      GetClientLookupListData(project.projectType === 0);
    }
  }, [project.projectType]);

  useEffect(() => {
    GetZoneLookupListData();
    GetSiteEngineerLookupListData();
    GetTeamLeadLookupListData();
    GetProjectManagerLookupListData();
    GetProjectStatusLookupListData();
    // GetCityLookupListData();
    GetStateLookupListData();
    GetDivisionalLookupListData();
  }, []);

  if (!isOpen) return null;

  // Fetch Project Data for Update
  const GetProjectModalData = async (KeyID) => {
    setLoader(true);
    try {
      const data = await GetProjectModel(KeyID);
      if (data.statusCode === 200 && data.responseData?.data) {
        const modalData = data.responseData.data;

        // Populate project state
        // setProject({
        //   projectKeyID: modalData.project.clientProjectID,
        //   projectName: modalData.project.projectName || "",
        //   price: modalData.project.price || "",
        //   timeLineDays: modalData.project.timeLineDays || "",
        //   paymentTerms: modalData.project.paymentTerms || "",
        //   remark: modalData.project.remark || "",
        // });

        setProject({
          ...modalData,
          startDate: modalData.startDate?.split("T")[0] || null,
          endDate: modalData.endDate?.split("T")[0] || null,

        })

        const documents =
          modalData.documentTypeEmployeeList?.map((item) => ({
            id: item.documentTypeID,
            timeSpan: item.timeSpan ?? 1,
            employeeID: item.employeeID ?? null,
            fileName: item.documentTypeName || "",
          })) || [];

        setDocumentDetails(documents);
        // Set serviceKeyIDs and serviceHours based on the response
        const serviceIDs = modalData.serviceKeyIDs.map((s) => s.serviceKeyID);
        setServiceKeyIDs(serviceIDs);

        // Map hours and price for each selected service
        const hoursMap = {};
        modalData.serviceKeyIDs.forEach((s) => {
          hoursMap[s.serviceKeyID] = {
            hours:
              s.budgetedHours !== null ? s.budgetedHours.toFixed(2) : "0.00",
            price: s.servicePrice !== null ? s.servicePrice.toFixed(2) : "0.00",
            canDelete: s.canDelete,
          };
        });

        setServiceHours(hoursMap);

        // Set project ID for update
        setStatusObj({
          ...stageObj,
          clientProjectID: modalData.project.clientProjectID,
        });


      }
    } catch (error) {
      console.error("Error fetching project modal data:", error);
    } finally {
      setLoader(false);
    }
  };

  const updateField = (field, value) => {
    setProject((prev) => ({ ...prev, [field]: value }));
  };
  const handleStartDateChange = (selectedDate) => {
    const fromDateUTC = new Date(Date.UTC(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate()
    ));
    const fromDateISO = fromDateUTC.toISOString();
    updateField("startDate", fromDateISO);
    updateField("endDate", ""); // Reset toDate on new start date selection

  };

  // Handle End Date selection
  const handleEndDateChange = (selectedDate) => {
    const toDateUTC = new Date(Date.UTC(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate()
    ));
    const toDate = toDateUTC.toISOString();
    const fromDate = new Date(project.startDate);

    setErrorMessage("");
    if (toDateUTC >= fromDate) {
      updateField("endDate", toDate);
    } else {
      setErrorMessage(
        "End date must be greater than or equal to the start date."
      );
      updateField("endDate", "");
    }
  };

  // const GetServiceLookupListData = async () => {
  //   try {
  //     const data = await GetServiceLookupList(
  //       PanalModuleName,
  //       authDetails.userKeyID
  //     );
  //     if (data?.statusCode === 200 && data?.responseData?.data) {
  //       const List = data.responseData.data.map((item) => ({
  //         value: item.serviceKeyID,
  //         label: item.serviceName,
  //       }));
  //       setServiceLookupList(List);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const GetStateLookupListData = async () => {
    try {
      const data = await GetStateLookupList();

      if (data?.statusCode === 200 && data?.responseData?.data) {
        const List = data.responseData.data.map((item) => ({
          value: item.stateID,
          label: item.stateName,
        }));
        setStateLookupList(List);
      }
    } catch (error) {
      console.log(error);
    }

  }

  const GetDivisionalLookupListData = async () => {
    try {
      const data = await GetDivisionalCategoryLookupList(


      );
      if (data?.statusCode === 200 && data?.responseData?.data) {
        const List = data.responseData.data.map((item) => ({
          value: item.divisionalCategoryID,
          label: item.divisionalCategory,
        }));
        setDivisionalCategoryLookupList(List);
      }
    } catch (error) {
      console.log(error);
    }

  }

  const GetSubDivisionalLookupListData = async () => {

    try {
      const data = await GetSubDivisionalCategoryLookupList(project.divisionalCategoryID);
      if (data?.statusCode === 200 && data?.responseData?.data) {
        const List = data.responseData.data.map((item) => ({
          value: item.dscid,
          label: item.dscName,
        }));
        setSubDivisionalCategoryLookupList(List);
      }
    } catch (error) {
      console.log(error);
    }

  }
  const GetZoneLookupListData = async () => {
    try {
      // let response = await GetCountryLookupList();
      let response = await ZoneLookupList();


      // Check if response contains data
      if (response?.statusCode === 200) {
        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({
          value: item.zoneID,
          label: item.zoneName,
        }));
        // Confirm correct mapping

        setZoneDivisionalLookupList(zoneDivisionalOptions);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching zone divisional lookup list:", error);
    }
  }

  const GetSiteEngineerLookupListData = async () => {
    try {
      // let response = await GetCountryLookupList();
      let response = await GetSiteEngineerLookupList(7);


      // Check if response contains data
      if (response?.statusCode === 200) {
        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({
          value: item.userID,
          label: item.name,
        }));
        // Confirm correct mapping

        setSiteEngineerLookupList(zoneDivisionalOptions);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching zone divisional lookup list:", error);
    }
  }


  const GetTeamLeadLookupListData = async () => {
    try {
      // let response = await GetCountryLookupList();
      let response = await GetTeamLeadLookupList(6);


      // Check if response contains data
      if (response?.statusCode === 200) {
        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({
          value: item.userID,
          label: item.name,
        }));
        // Confirm correct mapping

        setTeamLeadLookupList(zoneDivisionalOptions);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching zone divisional lookup list:", error);
    }
  }


  const GetProjectManagerLookupListData = async () => {
    try {
      // let response = await GetCountryLookupList();
      let response = await GetProjectManagerLookupList(3);


      // Check if response contains data
      if (response?.statusCode === 200) {
        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({
          value: item.userID,
          label: item.name,
        }));
        // Confirm correct mapping

        setProjectManagerLookupList(zoneDivisionalOptions);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching zone divisional lookup list:", error);
    }
  }


  const GetProjectStatusLookupListData = async () => {
    try {
      // let response = await GetCountryLookupList();
      let response = await GeStatusLookupList();


      // Check if response contains data
      if (response?.statusCode === 200) {
        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({

          value: item.projectStatusID,
          label: item.projectStatusName,
        }));
        // Confirm correct mapping

        setProjectStatusLookupList(zoneDivisionalOptions);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching zone divisional lookup list:", error);
    }
  }

  const GetClientLookupListData = async (clientType) => {
    try {
      // let response = await GetCountryLookupList();
      let response = await GetClientTypeLookupList(clientType);


      // Check if response contains data
      if (response?.statusCode === 200) {
        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({

          value: item.clientID,
          label: item.clientName,
          partiesKeyID: item.partiesKeyID,
          costToTechnoland: item.costToTechnoland,
        }));
        // Confirm correct mapping

        setClientLookupList(zoneDivisionalOptions);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching zone divisional lookup list:", error);
    }
  }


  const GetCityLookupListData = async (stateID) => {
    try {
      // let response = await GetCountryLookupList();
      let response = await GetCityLookupList(stateID);


      // Check if response contains data
      if (response?.statusCode === 200) {
        const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({

          value: item.cityID,
          label: item.cityName,
        }));
        // Confirm correct mapping

        setCityLookupList(zoneDivisionalOptions);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching zone divisional lookup list:", error);
    }
  }

  // Handlers for project fields
  const handleProjectNameChange = (e) => {
    const value = e.target.value;
    if (/^[a-zA-Z0-9\s]*$/.test(value)) {
      setProject((prev) => ({
        ...prev,
        projectName: value,
      }));
    }
  };

  const handlePriceChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    value = value.slice(0, 7);
    setProject({ ...project, price: value });
  };

  const handleTimelineChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    value = value.slice(0, 5);
    setProject({ ...project, timeLineDays: value });
  };

  const handlePaymentTermsChange = (e) => {
    setProject({ ...project, paymentTerms: e.target.value });
  };

  const handleRemarkChange = (e) => {
    setProject({ ...project, remark: e.target.value });
  };


  const getFileNameFromUrl = (url) => {
    if (!url) return "";
    return url.substring(url.lastIndexOf('/') + 1);
  };

  const NavigateToTender = () => {
    navigate("/addUpdateClient", {
      state: {
        dscid: project.divisionalSubCategory,
        projectKeyID: projectKeyID,

        partiesKeyID:
          clientLookupList.find((x) => x.value === project.clientID)?.partiesKeyID || null,

        divisionalCategoryID: project.divisionalCategoryID,
        clientName:
          clientLookupList.find((x) => x.value === project.clientID)?.label || "",

        category:
          divisionalCategoryLookupList.find(
            (x) => x.value === project.divisionalCategoryID
          )?.label || "",

        department:
          subDivisionalCategoryLookupList.find(
            (x) => x.value === project.divisionalSubCategory
          )?.label || "",

        projectName: project.projectName,
        partiesId: 2
      },
    });

  }

  const handleSubmit = async () => {

    let requiredFields = [
      project.projectName,
      project.zoneID,
      project.clientID,
      project.projectType,
      project.divisionalCategoryID,
      project.divisionalSubCategory,
      project.stateID,
      project.cityID,
    ];

    if (project.projectType === 1) {
      requiredFields.push(
        project.clientCost,
        project.technolandCost,
        project.startDate,
        project.endDate,
        project.assignedPM,
        project.assignedTL
      );
    }

    // If ANY field is missing or empty, show error
    const hasEmpty = requiredFields.some(
      (field) => field === "" || field === null || field === undefined
    );

    if (hasEmpty) {
      setRequireErrorMessage(true);
      return;
    }

    setRequireErrorMessage(false); // optional: clear error

    const documentTypeEmployeeList = documentDetails.map((doc) => ({
      documentTypeID: doc?.documentTypeID || doc?.id,
      timeSpan: Number(doc.timeSpan) || 0,
      employeeID: doc.employeeID,
    }));

    setLoader(true);
    try {

      const data = await AddUpdateProject({ ...project, userKeyID, documentTypeEmployeeList });
      if (data?.statusCode === 200 || data?.status === 200) {

        setProjectKeyID(data?.responseData?.data)
        if (project.projectType === 0) {
          setModelAction(
            modelRequestData.Action === null ? "Add Tender" : "Update Tender"
          )
        } else {
          setModelAction(modelRequestData.Action === null ? "Add" : "Update")
        }
        setLoader(false);
        setIsAddUpdateDone(true);
        setShowSuccessPopupModal(true);
      } else {
        setLoader(false);
        setIsErrorOpen(true);
        const errorMessage = data?.response.data.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error while adding/updating project:", error);
    }
  };

  // const createDocumentRows = (categoryName) => {
  //   const documentList =
  //     GetDocumentDetailsData(categoryName);

  //   return documentList.map(
  //     (document, index) => ({
  //       id: `${categoryName}-${index}`,
  //       fileName: document.fileName,
  //       timeSpan: document.timeSpan,
  //       employeeID: null,
  //     })
  //   );
  // };

  const getAssignedEmployeeOptions = () => {
    const employeeOptions = [];

    // Assigned PM
    if (project.assignedPM !== null && project.assignedPM !== undefined) {
      const pm = projectMangerLookupList.find(
        (item) =>
          String(item.value) === String(project.assignedPM)
      );

      if (pm) {
        employeeOptions.push({
          value: pm.value,
          label: `${pm.label} - PM`,
        });
      }
    }

    // Assigned TL
    if (Array.isArray(project.assignedTL)) {
      project.assignedTL.forEach((employeeID) => {
        const teamLead = teamLeadLookupList.find(
          (item) =>
            String(item.value) === String(employeeID)
        );

        if (teamLead) {
          employeeOptions.push({
            value: teamLead.value,
            label: `${teamLead.label} - TL / Site In-Charge`,
          });
        }
      });
    }

    // Site Engineer
    if (Array.isArray(project.siteEngineer)) {
      project.siteEngineer.forEach((employeeID) => {
        const engineer = siteEngineerLookupList.find(
          (item) =>
            String(item.value) === String(employeeID)
        );

        if (engineer) {
          employeeOptions.push({
            value: engineer.value,
            label: `${engineer.label} - Site Engineer`,
          });
        }
      });
    }

    return employeeOptions;
  };

  const handleDocumentTimeSpanChange = (rowID, value) => {
    let inputValue = value.replace(/\D/g, "");

    if (inputValue === "") {
      inputValue = "";
    } else {
      inputValue = Number(inputValue);
    }

    setDocumentDetails((prev) =>
      prev.map((row) =>
        row.id === rowID
          ? {
            ...row,
            timeSpan: inputValue,
          }
          : row
      )
    );
  };

  const handleDocumentEmployeeChange = (
    rowID,
    selectedOption
  ) => {
    setDocumentDetails((prev) =>
      prev.map((row) =>
        row.id === rowID
          ? {
            ...row,
            employeeID: selectedOption?.value || null,
          }
          : row
      )
    );
  };

  return (
    <div className="fixed inset-0 flex items-start justify-center z-50 px-2 sm:px-4 pt-3">
      {/* Background Overlay */}
      <div className="fixed inset-0 bg-black opacity-50"></div>

      {/* Modal Box */}
      <div className="bg-white rounded-lg shadow-lg z-10 
  w-full max-w-[95%] sm:max-w-[80%] md:max-w-[70%] lg:max-w-[60%] 
  max-h-[90vh] flex flex-col overflow-hidden">
        <div className="bg-[#ECF6FF] px-4 py-3 border-b sticky top-0 z-20">
          <h2 className="text-sm sm:text-base font-semibold text-gray-800">
            {modelRequestData.Action === null ? "Add New Project" : "Update Project"}
          </h2>
        </div>

        <div className="p-6 sm:p-8 space-y-4 overflow-y-auto flex-1">
          {/* Project Details */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-12">

            <div>
              <label className="block text-12 font-medium text-gray-700 mb-2">
                Project Type <span className="text-red-600">*</span>
              </label>

              <div className="flex items-center gap-6">
                <label
                  className={`flex items-center gap-2 ${modelRequestData.Action !== null || modelRequestData.clientType !== null
                    ? "cursor-not-allowed "
                    : "cursor-pointer"
                    }`}
                >
                  <input
                    type="radio"
                    name="projectType"
                    checked={project.projectType === 0}
                    disabled={modelRequestData.Action !== null || modelRequestData.clientType !== null}
                    onChange={() => {
                      setProject({
                        projectType: 0,
                        projectName: ""
                      })
                      setDocumentDetails([])
                    }}
                    className="h-4 w-4 text-blue-600"
                  />
                  <span className="text-sm text-gray-700">Tender Project</span>
                </label>

                <label
                  className={`flex items-center gap-2 ${modelRequestData.Action !== null || modelRequestData.clientType !== null
                    ? "cursor-not-allowed "
                    : "cursor-pointer"
                    }`}
                >
                  <input
                    type="radio"
                    name="projectType"
                    checked={project.projectType === 1}
                    disabled={modelRequestData.Action !== null || modelRequestData.clientType !== null}
                    onChange={() => {
                      setProject({
                        projectType: 1,
                        projectName: ""
                      })
                      setDocumentDetails([])
                    }}
                    className="h-4 w-4 text-blue-600"
                  />
                  <span className="text-sm text-gray-700">Non Tender Project</span>
                </label>
              </div>

              {requireErrorMessage && !project.projectType && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div>
            <div></div>

            {/* client */}
            <div>
              <label className="block text-12 font-medium text-gray-700 mb-1">
                Client <span className="text-red-600">*</span>
              </label>
              <Select
                placeholder='Select Client'
                id="clientID"
                options={clientLookupList}
                value={
                  clientLookupList.find(
                    (option) => option.value === project.clientID
                  ) || null
                }
                onChange={(selectedOptions) =>
                  setProject((prev) => ({
                    ...prev,
                    clientID: selectedOptions.value,
                    technolandCost: selectedOptions.costToTechnoland ?? prev.technolandCost,
                  }))
                }
                menuPosition="fixed"
                menuPlacement="auto"
                styles={{
                  ...customSelectStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {requireErrorMessage && !project.clientID && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div>

            {/* Project Name */}
            <div>
              <label className="block text-12 font-medium text-gray-700 mb-1">
                Project Name <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                maxLength={255}
                className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                placeholder="Project Name"
                value={project.projectName}
                // onChange={(e) => {
                // const formatted = formatInputValue(e.target.value);

                // If whitespace entered first → do not update
                // if (formatted === null) return;
                // }}
                onChange={(e) => setProject({
                  ...project,
                  projectName: e.target.value?.trimStart()
                })}


              />
              {requireErrorMessage && !project.projectName && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div>

            {/* State  */}
            <div>
              <label className="block text-12 font-medium text-gray-700 mb-1">
                State <span className="text-red-600">*</span>
              </label>
              <Select
                isClearable
                placeholder='Select State'
                id="stateID"
                options={stateLookupList}
                value={
                  stateLookupList.find(
                    (option) => option.value === project?.stateID
                  ) || null
                }
                onChange={(selectedOptions) =>
                  setProject((prev) => ({
                    ...prev,
                    stateID: selectedOptions?.value
                  }))
                }
                menuPosition="fixed"
                menuPlacement="auto"
                styles={{
                  ...customSelectStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {requireErrorMessage && !project.stateID && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div>

            {/* city  */}
            <div>
              <label className="block text-12 font-medium text-gray-700 mb-1">
                City <span className="text-red-600">*</span>
              </label>
              <Select
                placeholder='Select City'
                id="cityID"
                options={cityLookupList}
                value={
                  cityLookupList.find(
                    (option) => option.value === project.cityID
                  ) || null
                }
                isDisabled={!project.stateID}
                onChange={(selectedOptions) =>
                  setProject((prev) => ({
                    ...prev,
                    cityID: selectedOptions.value
                  }))
                }
                menuPosition="fixed"
                menuPlacement="auto"
                styles={{
                  ...customSelectStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}

              />

              {requireErrorMessage && !project.cityID && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div>

            {/* Zone  */}
            <div>
              <label className="block text-gray-700 text-12 mb-1">
                Division <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                id="zoneID"
                options={zoneDivisionalLookupList}
                value={
                  zoneDivisionalLookupList.find(
                    (option) => option.value === project.zoneID
                  ) || null
                }
                onChange={(selectedOptions) =>
                  setProject((prev) => ({
                    ...prev,
                    zoneID: selectedOptions.value
                  }))
                }
                menuPosition="fixed"
                menuPlacement="auto"
                styles={{
                  ...customSelectStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {requireErrorMessage &&
                (project.zoneID === null || project.zoneID === undefined) && (
                  <label className="validation">{ERROR_MESSAGES}</label>
                )}
            </div>

            {/* Divisional category*/}

            <div>
              <label className="block text-gray-700 text-12 mb-1">
                Category <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                isClearable
                className="w-full"
                id="divisionalCategoryID"
                options={divisionalCategoryLookupList}
                onChange={(selectedOption) => {
                  const categoryID =
                    selectedOption?.value || null;



                  setProject({
                    ...project,
                    divisionalCategoryID: categoryID
                  })

                  if (categoryID) {
                    GetDocumentDetailsData(categoryID);
                  } else {
                    setDocumentDetails([]);
                  }
                  //fetch subdivisional agains divisional category
                }}

                value={
                  divisionalCategoryLookupList.find(
                    (option) => option.value === project?.divisionalCategoryID
                  ) || null
                }
                menuPosition="fixed"
                menuPlacement="auto"
                styles={{
                  ...customSelectStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {requireErrorMessage &&
                (project.divisionalCategoryID === "" ||
                  project.divisionalCategoryID === undefined ||
                  project.divisionalCategoryID === null) ? (
                <label className="validation">{ERROR_MESSAGES}</label>
              ) : (
                ""
              )}
            </div>

            {/* Divisional Sub-category*/}

            <div>
              <label className="block text-gray-700 text-12 mb-1">
                Department <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                className="w-full"
                id="divisionalSubCategory"
                options={subDivisionalCategoryLookupList}
                onChange={(value) => {
                  setProject({
                    ...project,
                    divisionalSubCategory: value.value
                  })
                }}

                value={
                  subDivisionalCategoryLookupList.find(
                    (option) => option.value === project.divisionalSubCategory
                  ) || null
                }
                isDisabled={!project.divisionalCategoryID}
                menuPosition="fixed"
                menuPlacement="auto"
                styles={{
                  ...customSelectStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {requireErrorMessage &&
                (project.divisionalSubCategory === "" ||
                  project.divisionalSubCategory === undefined ||
                  project.divisionalSubCategory === null) ? (
                <label className="validation">{ERROR_MESSAGES}</label>
              ) : (
                ""
              )}
            </div>



            {/* technoland cost  */}
            {project.projectType === 1 && (
              <>
                <div>
                  <label className="block text-12 font-medium text-gray-700 mb-1">
                    Technoland Cost <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="number"
                    min={0}
                    className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    placeholder="Technoland Cost (₹)"
                    onKeyDown={(e) => {
                      // Prevent entering "-" or "e" for scientific notation
                      if (e.key === "-" || e.key === "e" || e.key === "+") {
                        e.preventDefault();
                      }
                    }}
                    value={project.technolandCost}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Ensure value is not negative
                      if (Number(value) < 0) return;

                      setProject({ ...project, technolandCost: value })
                    }}
                  />
                  {requireErrorMessage && !project.technolandCost && (
                    <label className="validation">{ERROR_MESSAGES}</label>
                  )}
                </div>

                {/* client cost  */}
                <div>
                  <label className="block text-12 font-medium text-gray-700 mb-1">
                    Client Cost <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="number"
                    id="clientCost"
                    min={0}
                    className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    placeholder="Client Cost (₹)"
                    value={project.clientCost}
                    onKeyDown={(e) => {
                      // Prevent entering "-" or "e" for scientific notation
                      if (e.key === "-" || e.key === "e" || e.key === "+") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Ensure value is not negative
                      if (Number(value) < 0) return;
                      setProject({ ...project, clientCost: value });
                    }}
                  />
                  {requireErrorMessage && !project.clientCost && (
                    <label className="validation">{ERROR_MESSAGES}</label>
                  )}
                </div>

                {/* start date  */}
                <div>
                  <label className="block text-12 font-medium text-gray-700 mb-1">
                    Start Date <span className="text-red-600">*</span>
                  </label>
                  <DatePicker
                    minDate={minDate}

                    format="dd/MM/y"
                    dayPlaceholder="dd"
                    monthPlaceholder="mm"
                    yearPlaceholder="yyyy"
                    value={project.startDate}
                    onChange={handleStartDateChange}
                    className="p-1 border rounded-md text-12"
                  />
                  {/* <input
                type="date"
                className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                placeholder="Technoland Cost"
                value={project.startDate}
                onChange={(e) => setProject({ ...project, startDate: e.target.value })}
              /> */}
                  {requireErrorMessage && !project.startDate && (
                    <label className="validation">{ERROR_MESSAGES}</label>
                  )}
                </div>

                {/* end date  */}

                <div>
                  <label className="block text-12 font-medium text-gray-700 mb-1">
                    End Date <span className="text-red-600">*</span>
                  </label>
                  <DatePicker
                    minDate={minDate}

                    format="dd/MM/y"
                    dayPlaceholder="dd"
                    monthPlaceholder="mm"
                    yearPlaceholder="yyyy"
                    value={project.endDate}
                    onChange={handleEndDateChange}
                    className="p-1 border rounded-md text-12"
                  />

                  {requireErrorMessage && !project.endDate && (
                    <label className="validation">{ERROR_MESSAGES}</label>
                  )}
                </div>
              </>
            )}

            {/* status  */}

            {/* 
            <div>
              <label className="block text-12 font-medium text-gray-700 mb-1">
                Status <span className="text-red-600">*</span>
              </label>
              <Select
                placeholder="Select Status"
                className="w-full"
                options={projectStatusLookupList}
                onChange={(value) => {

                  setProject({
                    ...project,
                    projectStatusID: value.value
                  })
                }}
                styles={globalSelectStyles}
                value={
                  projectStatusLookupList.find(
                    (option) => option.value === project.projectStatusID
                  ) || null
                }
              />

              {requireErrorMessage && !project.projectStatusID && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div> */}


            {(
              (
                (project.projectType === 1 || modelRequestData?.isTenderToProject)
              ) ||
              (
                project.projectType === 0 &&
                modelRequestData?.Action === "Update"
              )
            ) && (
                <>
                  <div>
                    <label className="block text-12 font-medium text-gray-700 mb-1">
                      Assigned PM <span className="text-red-600">*</span>
                    </label>
                    <Select
                      placeholder='Select Project Manager'
                      options={projectMangerLookupList}
                      onChange={(value) => setProject({
                        ...project,
                        assignedPM: value.value
                      })}
                      value={
                        projectMangerLookupList.find(
                          (option) => option.value === project.assignedPM
                        ) || null
                      }

                      menuPosition="fixed"
                      menuPlacement="auto"
                      styles={{
                        ...customSelectStyles,
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                    {requireErrorMessage && !project.assignedPM && (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    )}
                  </div>
                  <div>
                    <label className="block text-12 font-medium text-gray-700 mb-1">
                      Assigned TL / Site In-Charge <span className="text-red-600">*</span>
                    </label>
                    <Select
                      placeholder='Team Lead / Site In-Charge'
                      options={teamLeadLookupList}
                      onChange={(selectedOptions) =>
                        setProject((prev) => ({
                          ...prev,
                          assignedTL: selectedOptions ? selectedOptions.map((opt) => opt.value) : []
                        }))
                      }

                      value={teamLeadLookupList.filter((item) => project.assignedTL?.includes(item.value))}
                      isMulti
                      menuPosition="fixed"
                      menuPlacement="auto"
                      styles={{
                        ...customSelectStyles,
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                    {requireErrorMessage && !project.assignedTL?.length && (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    )}

                  </div>

                  <div>
                    <label className="block text-12 font-medium text-gray-700 mb-1">
                      Site Engineer
                    </label>
                    <Select
                      placeholder='Site Engineer'
                      options={siteEngineerLookupList}
                      onChange={(selectedOptions) =>
                        setProject((prev) => ({
                          ...prev,
                          siteEngineer: selectedOptions ? selectedOptions.map((opt) => opt.value) : []
                        }))
                      }

                      value={siteEngineerLookupList.filter((item) => project.siteEngineer?.includes(item.value))}
                      isMulti
                      menuPosition="fixed"
                      menuPlacement="auto"
                      styles={{
                        ...customSelectStyles,
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </>
              )}


            <div>
              <label className="block text-12 font-medium text-gray-700 mb-1">
                Upload Document
              </label>

              {/* Flex row: button + filename */}
              <div className="flex items-center gap-3 w-full">

                {/* Hidden file input */}
                <input
                  id="imageURL"
                  type="file"
                  accept="
                          .pdf,
                          .xls,
                          .xlsx,
                          .doc,
                          .docx,
                          application/pdf,
                          application/vnd.ms-excel,
                          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                          application/msword,
                          application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  className="hidden"
                  onChange={async (e) => {
                    let file = e.target.files[0];
                    if (!file) return;

                    const ext = file.name.split('.').pop().toLowerCase();
                    const allowedExt = ["pdf", "xls", "xlsx", "doc", "docx"];


                    if (!allowedExt.includes(ext)) {
                      setProject({
                        ...project,
                        imageURL: "",
                        errors: { ...project.errors, uploadMedia: "Only PDF and Excel files are allowed." }
                      });
                      return;
                    }


                    try {
                      setLoader(true);
                      const response = await UploadImageWithNodeApi({
                        imageFile: file,
                        userId: userKeyID,
                        moduleName: "Project",
                        projectName: "Technoland",
                      });

                      if (response.success) {
                        setProject({
                          ...project,
                          imageURL: response.s3Url,
                          errors: { ...project.errors, uploadMedia: "" }
                        });
                      }
                    } catch (error) {
                      console.log("error", error);
                    } finally {
                      setLoader(false);
                    }
                  }}
                />

                {/* Upload Button */}
                <label
                  htmlFor="imageURL"
                  className="cursor-pointer whitespace-nowrap bg-blue-500 text-white font-medium px-3 py-2 rounded-md shadow-sm hover:bg-primary/90 active:scale-95 transition-all"
                >
                  Upload File
                </label>

                {/* File name on right side (trim with ellipsis) */}
                {project.imageURL && (
                  <a
                    href={project?.imageURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="View File"
                    className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
                  >
                    <span>View file</span>
                    <FaEye className="text-xl cursor-pointer" />
                  </a>
                )}


              </div>
              <p style={{ color: "#777", fontSize: "12px" }}>
                Upload only Excel, Word or PDF
              </p>
              {project?.errors?.uploadMedia && (
                <p className="text-red-500 text-11 mt-1">
                  {project?.errors?.uploadMedia}
                </p>
              )}
            </div>
          </div>

          {/* Document Details Table */}

          {(
            (
              (project.projectType === 1 || modelRequestData?.isTenderToProject) &&
              documentDetails.length > 0
            ) ||
            (
              project.projectType === 0 &&
              documentDetails.length > 0 &&
              modelRequestData?.Action === "Update"
            )
          ) && (
              <div className="mt-6">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-sm font-semibold text-gray-700">
                    Document Details
                  </h3>

                  <span className="text-xs text-gray-500">
                    Assign time span and employee
                  </span>
                </div>

                <div className="w-full  border rounded-lg">
                  <table className="w-full  border-collapse">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="border-b   text-center text-xs font-semibold text-gray-600">
                          Sr. No.
                        </th>

                        <th className="border-b   text-center text-xs font-semibold text-gray-600">
                          File Name
                        </th>

                        <th className="border-b   text-center text-xs font-semibold text-gray-600">
                          Time Span (Days)
                        </th>

                        <th className="border-b  py-3 text-center text-xs font-semibold text-gray-600">
                          Employee
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {documentDetails.map(
                        (row, index) => (
                          <tr
                            key={row.id}
                            className="hover:bg-gray-50"
                          >
                            {/* Sr No */}
                            <td className="border-b  text-center text-xs text-gray-600">
                              {index + 1}
                            </td>

                            {/* File Name */}
                            <td className="border-b text-center  ">
                              <span className="text-xs font-medium text-gray-700">
                                {row.fileName}
                              </span>
                            </td>

                            {/* Time Span */}
                            <td className="border-b text-center ">
                              <input
                                type="text"
                                inputMode="numeric"
                                value={row.timeSpan}
                                onChange={(e) =>
                                  handleDocumentTimeSpanChange(
                                    row.id,
                                    e.target.value
                                  )
                                }
                                className="w-[80px] border rounded-md text-center  py-2 text-xs outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Time span"
                              />
                            </td>

                            {/* Employee */}
                            <td className="border-b p-2 py-3 text-12 ">
                              <Select
                                placeholder="Select Employee"
                                className="w-full"
                                options={
                                  getAssignedEmployeeOptions()
                                }
                                value={
                                  getAssignedEmployeeOptions().find(
                                    (option) =>
                                      String(option.value) === String(row.employeeID)
                                  ) || null
                                }
                                onChange={(
                                  selectedOption
                                ) =>
                                  handleDocumentEmployeeChange(
                                    row.id,
                                    selectedOption
                                  )
                                }

                                menuPortalTarget={
                                  document.body
                                }
                                menuPosition="fixed"
                                styles={{
                                  ...customSelectStyles,
                                  option: (base) => ({
                                    ...base,
                                    fontSize: "12px", // dropdown option text-xs
                                  }),

                                  menuList: (base) => ({
                                    ...base,
                                    fontSize: "12px",
                                  }),

                                  menuPortal: (
                                    base
                                  ) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

        </div>
        {errorMessage && (
          <div className="text-center">
            <label className="validation ">{errorMessage}</label>
          </div>
        )}

        {/* Footer Buttons */}
        <div className="bg-gray-50 px-4 py-3 border-t flex justify-end gap-3 sticky bottom-0 z-20">
          <button
            type="button"
            className="px-4 py-2 bg-gray-300 rounded-md text-sm"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="bg-gradient-to-r from-[#0E4C84] to-[#00A7C1] hover:from-[#135EA0] hover:to-[#00B8D4] text-white px-5 py-2 rounded-lg text-12 font-medium shadow-md shadow-cyan-500/30 hover:shadow-cyan-400/40 transition-all duration-300"
          >
            Submit
          </button>
        </div>

        {/* Success Modal */}
        <SuccessModal
          isOpen={showSuccessPopupModal}
          onClose={() => {
            onClose();
            setShowSuccessPopupModal(false);
            if (project.projectType === 0 && modelRequestData.Action === null) {
              NavigateToTender();
            }
          }}
          modelAction={modelAction}
          actionMessage={`${project.projectName} project`}
        />

        <ErrorModal
          isOpen={isErrorOpen}
          onClose={() => setIsErrorOpen(false)}
          errorMessage={errorMessage}
        />
      </div>
    </div>
  );
};

export default AddProjectModal;